import {useQuery} from 'hooks/graphql'
import {CityByAddressSearchResult, SEARCH_PAYROLL_REPORT_CITY_BY_ADDRESS} from './query'

export const useSearchPayrollReportCityByAddress = (postcode: number | undefined) => {
  const {data} = useQuery<CityByAddressSearchResult>(SEARCH_PAYROLL_REPORT_CITY_BY_ADDRESS, {
    fetchPolicy: 'network-only',
    variables: {
      postcode,
    },
  })

  return data?.client?.searchPayrollReportCityByAddress
}
